<template>
    <glm-layout>
        <world-map :specials="$page.props.mapCountries" height="200px">
            <div class="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8 flex items-center h-full justify-start">
                <div class="rounded-md max-w-lg inline-block p-2 bg-grey-700 text-white mt-3">
                    <h3 class="font-bold font-serif text-3xl">
                        Privacy Policy
                    </h3>
                </div>
            </div>
        </world-map>

        <page-content class="mt-12 mb-24 prose">
            <div v-html="policy"></div>
        </page-content>
    </glm-layout>
</template>

<script>
import GlmLayout from '@/Layouts/GlmLayout'
import WorldMap from '@/Components/WorldMap'
import PageContent from '@/Components/PageContent'

export default {
    props: ['policy'],

    components: {
        PageContent,
        WorldMap,
        GlmLayout,
    },

    data () {
        return {
            //
        }
    },
}
</script>
